import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useLocalStorage} from '@aboutyou/storage';
import {useTimedOut} from '@aboutyou/ui-components';
import {useEffect} from 'react';

const PERSONALIZED_FILTER_HINT_KEY = 'personalized-filters-hint-shown';

export const usePersonalizedFiltersHint = (hintVisibleTimeMs: number) => {
  const isHydrationDone = useHydrationDone();
  const delayBeforeHidingHint = useTimedOut(hintVisibleTimeMs);

  const onCloseHint = () => {
    setHintWasShown(true);
  };

  const [hintWasShown, setHintWasShown] = useLocalStorage<boolean>({
    defaultValue: false,
    key: PERSONALIZED_FILTER_HINT_KEY,
  });

  const shouldShowHint = isHydrationDone && !hintWasShown;

  useEffect(() => {
    // To ensure that the local storage update occurs only when the component mounts client-side,
    // it is necessary to use the useEffect hook as local storage is unavailable during server-side rendering.
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    if (delayBeforeHidingHint) {
      setHintWasShown(true);
    }
  }, [delayBeforeHidingHint, setHintWasShown]);

  return {
    shouldShowHint,
    closeHint: onCloseHint,
  };
};
